import { useMemo } from "react";

import { useAppSelector } from "../../../Store/Hooks";
import { isRole, ROLES } from "../../../Utils/Constants/RoleConstants";
import {
  STORAGE_KEYS,
  getFromLocalStorage,
} from "../../../Utils/Helper/LocalStorage";

/**
 * Privileged Team Views access (same gate as App / Hawkeye ops tools):
 * Vendor Admin, C-Level, Executive Sponsor Lead, or executiveOps.
 * Gates last-login visibility and Reassign / Remove actions.
 */
export function resolveTeamViewsPrivilegedAccess(
  userRole: string | { name?: string } | null | undefined,
  executiveOps: boolean
): boolean {
  return (
    isRole(userRole, ROLES.VENDOR_ADMIN) ||
    isRole(userRole, ROLES.C_LEVEL) ||
    isRole(userRole, ROLES.EXECUTIVE_SPONSOR_LEAD) ||
    Boolean(executiveOps)
  );
}

export function useTeamViewsPrivilegedAccess(): boolean {
  const { user } = useAppSelector(state => state.authentication);
  const loggedInUser = getFromLocalStorage(STORAGE_KEYS.LOGGED_IN_USER);

  return useMemo(() => {
    const userRole = user?.user?.role || loggedInUser?.role;
    const executiveOps = Boolean(
      loggedInUser?.executiveOps || user?.user?.executive_ops
    );
    return resolveTeamViewsPrivilegedAccess(userRole, executiveOps);
  }, [loggedInUser, user]);
}
